module.exports = __webpack_public_path__ + "img/kf4.52c5ed53.jpg";